export const getCorrectOrderInRange = (from, to) => {
    if (from > 0 && to > 0 && from > to) {
        const temp = to;
        to = from;
        from = temp;
    }

    return {from, to};
};
